import React from 'react';
import {Route, Switch, useRouteMatch} from "react-router-dom";
import Assignments from "./Assignments";
import SubmitAssignment from "./SubmitAssignment";
import Submitted from './Submitted';

function StudentAssignments() {
  let {path} = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={Assignments} />
      <Route path={`${path}/submit-assignments/:assignmentId`} component={SubmitAssignment}/>
      <Route path={`${path}/submitted`} component={Submitted} />
    </Switch>
  );
}

export default StudentAssignments;